<template>
  <div class="row">
    <q-toggle class="col-md-2 q-pr-md q-mb-md" v-model="serial_config.enable" label="Enable Serial" />
    <q-select v-if="serial_config.enable" class="col-md-4 q-pr-md q-mb-md" dense filled v-model="serial_config.baudrate"
      label="BaudRate select" :options="baudrate_options" style="width: 200px">
    </q-select>
    <q-toggle v-if="serial_config.enable" class="col-md-2 q-pr-md q-mb-md" v-model="serial_config.enable_decoder"
      label="Enable Decoder" />
    <q-btn class="col-md-2 q-mb-md" label="Terminal" type="button" color="primary" @click="open_terminal = true" />
  </div>
  <div v-if="serial_config.enable_decoder && serial_config.enable" style="z-index: 1;position: absolute;"> 
    <q-btn class="q-mr-xs" label="Save" size="sm" text-color="black" icon="save" color="white" @click="setDecoder" />
    <q-btn class="q-mr-xs" label="Test" size="sm" text-color="black" icon="bug_report" color="white" @click="open_serial_test = true" />
  </div>

  <CodeEditor v-if="serial_config.enable_decoder && serial_config.enable" v-model="decoder" width="100%" height="350px" font-size="10px" theme="nnfx-dark">
  </CodeEditor>
  <q-dialog v-model="open_terminal" full-height full-width="" @before-hide="closeDialog">
    <SerialTerminal ref="terminal" />
  </q-dialog>
  <q-dialog v-model="open_serial_test" full-width="" @before-hide="updateDecoder">
    <TestSerialDecoder/>
  </q-dialog>
</template>

<style></style>

<script>
import SerialTerminal from './SerialTerminal.vue'
import TestSerialDecoder from './TestSerialDecoder.vue'
import CodeEditor from 'simple-code-editor';

export default {
  name: 'SerialConfiguration',
  components: {
    SerialTerminal,
    TestSerialDecoder,
    CodeEditor,
  },
  data() {
    return {
      decoder: "",
      serial_config: this.$store.state.serial,
      open_terminal: false,
      open_serial_test: false,
      baudrate_options: [110, 300, 600, 1200, 2400, 4800, 9600, 14400, 19200, 38400, 57600, 115200, 128000, 256000],
    }
  },
  mounted() {
    this.decoder = this.serial_config.decoder;
  },
  watch: {
    serial_config: {
      handler() {
        this.$store.commit('setSerialConfig', this.serial_config);
      },
      deep: true,
    },
  },
  methods: {
    closeDialog() {
      this.$refs.terminal.closeSerial()
    },
    setDecoder() {
      this.$store.commit('setDecoder', this.decoder);
      console.log(this.strippedHtml(this.decoder));
    },
    strippedHtml(text) {
      let regex = /(<([^>]+)>)/ig;

      return text.replace(regex, "");
    },
    updateDecoder() {
      this.decoder = this.serial_config.decoder;
    }
  }
}
</script>
